import { useHistory } from 'react-router-dom';
import Parser from 'html-react-parser';
import l from '../../../lang';
import { Routes } from '../../../config/routes';
import TopDashboardSection from '../../common/top-dashboard-section';
import Card from '../../common/card';
import CardInfo from '../../common/card-info';
import Popup from '../../common/popup';
import AlertMessages from '../alert-messages';
import { ReactComponent as InfoIcon } from '../../../assets/icons/info-unfilled.svg';
import { ReactComponent as TransactionsIcon } from '../../../assets/icons/transactions.svg';
import { ReactComponent as RefundsIcon } from '../../../assets/icons/refunds.svg';
import { ReactComponent as ReportsIcon } from '../../../assets/icons/reports.svg';
import { ReactComponent as ChargebacksIcon } from '../../../assets/icons/chargebacks.svg';
import settlementsIcon from '../../../assets/icons/movements-settlement.svg?url';
import './styles.scss';

interface MovementOption {
  id: string;
  labelKey: string;
  descKey: string;
  tooltipKey: string;
  route: string;
  icon: React.ReactNode;
}

const Movements = () => {
  const history = useHistory();

  const options: MovementOption[] = [
    {
      id: 'transactions',
      labelKey: 'menu.item.TRANSACTIONS',
      descKey: 'movements.transactions.desc',
      tooltipKey: 'movements.transactions.tooltip',
      route: Routes.TRANSACTIONS,
      icon: <TransactionsIcon className="movements-hub__icon" aria-hidden />,
    },
    {
      id: 'refunds',
      labelKey: 'menu.item.REFUNDS',
      descKey: 'movements.refunds.desc',
      tooltipKey: 'movements.refunds.tooltip',
      route: Routes.REFUNDS,
      icon: <RefundsIcon className="movements-hub__icon" aria-hidden />,
    },
    {
      id: 'settlements',
      labelKey: 'menu.item.SETTLEMENTS',
      descKey: 'movements.settlements.desc',
      tooltipKey: 'movements.settlements.tooltip',
      route: Routes.SETTLEMENTS,
      icon: <img src={settlementsIcon} alt="" className="movements-hub__icon" aria-hidden />,
    },
    {
      id: 'chargebacks',
      labelKey: 'menu.item.CHARGEBACKS',
      descKey: 'movements.chargebacks.desc',
      tooltipKey: 'movements.chargebacks.tooltip',
      route: Routes.CHARGEBACKS,
      icon: <ChargebacksIcon className="movements-hub__icon" aria-hidden />,
    },
    {
      id: 'reports',
      labelKey: 'menu.item.REPORTS',
      descKey: 'movements.reports.desc',
      tooltipKey: 'movements.reports.tooltip',
      route: Routes.REPORTS,
      icon: <ReportsIcon className="movements-hub__icon" aria-hidden />,
    },
  ];

  return (
    <div className="movements-hub">
      <TopDashboardSection title={l('menu.item.SIDEBAR_MOVIMIENTOS')} subtitle={l('movements.subheadline')} />
      <AlertMessages />
      <Card className="movements-hub__card">
        <div className="movements-hub__grid" role="list">
          {options.map(option => (
            <CardInfo key={option.id} bottomElement={<div className="movements-hub__accent-line" />}>
              <button
                type="button"
                className="movements-hub__item"
                role="listitem"
                onClick={() => history.push(option.route)}
              >
                <div
                  className="movements-hub__info"
                  onClick={e => e.stopPropagation()}
                  onKeyDown={e => e.stopPropagation()}
                >
                  <Popup
                    text={Parser(l(option.tooltipKey))}
                    icon={<InfoIcon className="movements-hub__info-icon" aria-hidden />}
                  />
                </div>
                <div className="movements-hub__icon-wrap">{option.icon}</div>
                <div className="movements-hub__label">{l(option.labelKey)}</div>
                <div className="movements-hub__desc">{l(option.descKey)}</div>
              </button>
            </CardInfo>
          ))}
        </div>
      </Card>
    </div>
  );
};

export default Movements;
